import { handleVersionMismatch } from 'actions/versionSync';
import { VersionMismatch } from 'services/BaseService';
import CardsService from 'services/CardsService';
import * as StoryletActions from 'actions/storylet';
import * as CardActionTypes from 'actiontypes/cards';
import { setNextAvailable } from 'actions/timer';
import computeNextActionsAt from 'utils/computeNextActionsAt';
import { ICardsService } from 'types/cards';
import { IAppState } from 'types/app';

const drawRequest = () => ({ type: CardActionTypes.DRAW_CARDS_REQUESTED });

const drawSuccess = (data: any) => ({
  type: CardActionTypes.DRAW_CARDS_SUCCESS,
  payload: data,
});

const drawFailure = (error: any) => ({
  type: CardActionTypes.FETCH_CARDS_FAILURE,
  error: true,
  status: error.response && error.response.status,
});

/** ----------------------------------------------------------------------------
 * DRAW
 -----------------------------------------------------------------------------*/
export default draw(new CardsService());

export function draw(service: ICardsService) {
  return () => async (dispatch: Function, getState: () => IAppState) => {
    // Check whether we're in the middle of a destructive edit on the player
    // state and, if so, return
    const { cards: { isDrawing, isFetching, isPlaying } } = getState();
    if (isDrawing || isFetching || isPlaying) {
      return;
    }

    dispatch(drawRequest());

    try {
      const { data } = await service.drawOpportunityCards();
      if (data.isInAStorylet) {
        dispatch(StoryletActions.putIn());
        // @ts-ignore
        dispatch(StoryletActions.fetchAvailable());
      }
      dispatch(drawSuccess(data));

      // Update timer with incoming data
      const { nextActionAt, currentTime } = data;

      dispatch(setNextAvailable(computeNextActionsAt({ nextActionAt, currentTime })));
    } catch (error) {
      if (error instanceof VersionMismatch) {
        dispatch(handleVersionMismatch(error));
      }
      dispatch(drawFailure(error));
    }
  };
}